import request from '@/utils/request'

export function getRequestLog() {
  return request({
    url: '/consent_request',
    method: 'get'
  })
}

export function postRequestLog(data) {
  return request({
    url: '/consent_request',
    method: 'post',
    data
  })
}

export function getRequestCount(params) {
  return request({
    url: '/consent_request/count',
    method: 'get',
    params
  })
}

export function updateRequest(id, data) {
  return request({
    url: `/consent_request/${id}`,
    method: 'put',
    data
  })
}

export function getConsentFormImage(id) {
  return request({
    url: `/upload/${id}`,
    method: 'get'
  })
}

export function getConsentForm() {
  return request({
    url: `/upload`,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/request.js